import React from 'react';

import QuotaWinterBossSale  from 'components/Tvendo/Sale/QuotaBPartner/WinterCuotas/QuotaBossSale/List.js';

export default function () {
  return <QuotaWinterBossSale  />;
}
